module.exports = __webpack_public_path__ + "img/pog_seer_stone.187fb4ee.png";